export default <T>(value?: T): value is T => Boolean(value)
